import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Select, Store } from '@ngxs/store';
import { ReportLayoutDefinition } from 'app/modules/reporting/reporting.types';
import { Report } from 'app/modules/reporting/state/actions';
import { ReportingState } from 'app/modules/reporting/state/state';
import { ReportLayout, ReportTypeQueryParamValues } from 'app/modules/reports/reports.types';
import { filter, map, Observable } from 'rxjs';

@Component({
  selector: 'app-report-select',
  templateUrl: './report-select.component.html',
  styleUrls: ['./report-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardReportSelectComponent implements OnInit {
  form = new FormGroup({
    reportLayout: new FormControl(null, [Validators.required]),
  });

  @Select(ReportingState.getLayouts) stateLayouts$: Observable<ReportLayout<ReportLayoutDefinition>[]>;

  layouts$: Observable<ReportLayout<ReportLayoutDefinition>[]>;

  constructor(
    private readonly matDialogRef: MatDialogRef<DashboardReportSelectComponent>,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      new Report.Get({
        report_types: [ReportTypeQueryParamValues.SingleObject, ReportTypeQueryParamValues.TimeSeries],
        per_page: 250,
      }),
    );

    this.layouts$ = this.stateLayouts$.pipe(
      filter((layouts) => layouts?.length > 0),
      map((layouts) => {
        return layouts
          .map((layout) => ({
            ...layout,
            definition: JSON.parse(layout.definition as unknown as string) as ReportLayoutDefinition,
          }))
          .filter((layout) => layout.definition?.visualizations?.length);
      }),
    );
  }

  add(): void {
    this.matDialogRef.close(this.form.getRawValue().reportLayout);
  }
}
